import Loadable from '../../components/loadable';

const AssetDrawer = Loadable({
  loader: () => import('../../pages/asset_drawer/asset_drawer'),
  type: 'drawer',
});

angular.module('shared').value('AssetDrawer', AssetDrawer);

const PreviewAssetModal = Loadable({
  loader: () => import('../../pages/asset_drawer/preview_asset_modal'),
  type: 'modal',
});

angular.module('shared').value('PreviewAssetModal', PreviewAssetModal);

const RemoveAssetModal = Loadable({
  loader: () => import('../../pages/asset_drawer/remove_asset_modal'),
  type: 'modal',
});

angular.module('shared').value('RemoveAssetModal', RemoveAssetModal);

const RenameAssetModal = Loadable({
  loader: () => import('../../pages/asset_drawer/rename_asset_modal'),
  type: 'modal',
});

angular.module('shared').value('RenameAssetModal', RenameAssetModal);

const RemoveFolderModal = Loadable({
  loader: () => import('../../pages/asset_drawer/remove_folder_modal'),
  type: 'modal',
});

angular.module('shared').value('RemoveFolderModal', RemoveFolderModal);

const ImportUrlModal = Loadable({
  loader: () => import('../../pages/asset_drawer/import_url_modal'),
  type: 'modal',
});

angular.module('shared').value('ImportUrlModal', ImportUrlModal);
